import React from 'react'
import './OrderStatusComponent.css'
import Vertical_Tracker from '../../Common-Component/Vertical_Tracker/Vertical_Tracker'

const OrderStatusComponent = () => {

    const data = [
        {
            date: "09",
            month: "Feb",
            customer_name: "MANJARI",
            remark: "SHIPMENT DELIVERED",
            time: "19:34"
        },
        {
            date: "09",
            month: "Feb",
            customer_name: "MANJARI",
            remark: "SHIPMENT DELIVERED",
            time: "19:34"
        },
        {
            date: "09",
            month: "Feb",
            customer_name: "MANJARI",
            remark: "SHIPMENT DELIVERED",
            time: "19:34"
        },
        {
            date: "09",
            month: "Feb",
            customer_name: "MANJARI",
            remark: "SHIPMENT DELIVERED",
            time: "19:34"
        },
        {
            date: "09",
            month: "Feb",
            customer_name: "MANJARI",
            remark: "SHIPMENT DELIVERED",
            time: "19:34"
        },

    ]


 
    return (
        <section className='OrderStatusComponent'>
            <div className='main_card_holder'>

                {data?.map((item) => {
                    return (
                        <div className='right_card'>
                            <div className='row'>
                                <div className='col-lg-2 col-md-2 col-sm-2 col-3 ms-0 me-0 p-0'>

                                    <div className='left_side'>
                                        <div className='outer_circle'>
                                            <div className='circle_div'>

                                            </div>
                                        </div>

                                        <div className='date_holder'>
                                            <p className='date_text'>{item?.date}</p>
                                            <p className='month_text'>{item?.month}</p>
                                        </div>

                                    </div>


                                </div>

                                <div className='col-lg-10 col-md-10 col-sm-10 col-9 '>
                                    <div className='location_info_div'>
                                        <div className='top_part'>

                                            <div className='location_label_div'>
                                                <p className='text'>Location:</p>
                                            </div>

                                            <div className='time_label_div'>
                                                <p className='text'>Time:{item?.time}</p>
                                            </div>
                                        </div>

                                        <div className='content_holder'>
                                            <p className='customer_name'>{item?.customer_name}</p>
                                            <p className='remark'>Remark : {item?.remark}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}


            </div>
        </section>
    )
}

export default OrderStatusComponent
